import zhBlogPosts from "./blogPosts.json";
import zhBghUrteile from "./bghUrteile.json";
import zhCalculator from "./calculator.json";
import zhCommon from "./common.json";
import zhDialogs from "./dialogs.json";
import zhExpertise from "./expertise.json";
import zhExpertiseSolutions from "./expertiseSolutions.json";
import zhFaqs from "./faqs.json";
import zhFooter from "./footer.json";
import zhHome from "./home.json";
import zhJudgmentsLanding from "./judgmentsLanding.json";
import zhLandingpages from "./landingpages.json";
import zhNav from "./nav.json";
import zhReferences from "./references.json";
import zhTeam from "./team.json";

/** Merged onto `deCatalog` via `mergeDeep`; omits `solvingTax` so German copy is inherited. */
export const zhMessageOverlay = {
  nav: zhNav,
  footer: zhFooter,
  home: zhHome,
  common: zhCommon,
  dialogs: zhDialogs,
  expertise: zhExpertise,
  blogPosts: zhBlogPosts,
  expertiseSolutions: zhExpertiseSolutions,
  team: zhTeam,
  references: zhReferences,
  landingpages: zhLandingpages,
  faqs: zhFaqs,
  calculator: zhCalculator,
  judgmentsLanding: zhJudgmentsLanding,
  bghUrteile: zhBghUrteile,
} as const;
